export default "__VITE_ASSET__DNX9VeAZ__"